import React from 'react'

const FormDashboardInput = React.forwardRef(({className, defaultValue, ...props}, ref) => {
  return (
    <input
      className={`rounded border py-2 px-4 text-sm ${className}`}
      style={{borderColor: '#ddd'}}
      defaultValue={defaultValue}
      ref={ref}
      {...props}
    />
  )
})

export { FormDashboardInput }
